export var terminateLoading = {
    loadingStep: [10, 20, 30, 60, 90],
    timerSteps: [0, 100, 200, 300, 400],
    defaultText: 'Terminating',
};
export var createLoading = {
    loadingStep: [10, 20, 30, 60, 90],
    timerSteps: [0, 1000, 3000, 5000, 7000],
    loadingStepText: [
        'Firing up the Docker container',
        'Setting server configuration',
        'Initializing the database',
        'Installing Neo4j Browser',
        'Loading the dataset',
    ],
    defaultText: 'Loading',
};
export var extendLoading = {
    loadingStep: [10, 20, 30, 60, 90],
    timerSteps: [0, 100, 200, 300, 400],
    defaultText: 'Extending',
};
